"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const __elasticsearch_1 = require("../../../__elasticsearch");
const __enums_1 = require("../../../__types/__enums");
const elasticsearchQuery_1 = require("../../__common/elasticsearchQuery");
function getUserIdsFilterFromInput(reportInput) {
    const { ReportParams } = reportInput;
    const { filters } = ReportParams;
    return filters;
}
function getProjectionFieldsFromReportInput(reportInput) {
    const { ReportProjection = {} } = reportInput;
    const { userProjection } = ReportProjection;
    const projection = userProjection && userProjection.includes;
    return projection;
}
function getUsers(query, projection) {
    return tslib_1.__awaiter(this, void 0, void 0, function* () {
        const body = { _source: projection, size: 5000, query };
        const elasticsearchClient = yield __elasticsearch_1.getElasticsearchClient(__enums_1.ElasticsearchIndicesUrlMapping.users);
        const esQuery = {
            index: __enums_1.ElasticsearchIndicesEnum.USER,
            type: __enums_1.ElasticsearchTypesEnum.USER,
            body
        };
        const result = yield elasticsearchClient.search(esQuery);
        return result.hits.hits.map((doc) => doc._source);
    });
}
function getUsersByIdsWithProjection(reportInput) {
    return tslib_1.__awaiter(this, void 0, void 0, function* () {
        const filters = getUserIdsFilterFromInput(reportInput);
        const projection = getProjectionFieldsFromReportInput(reportInput);
        const query = elasticsearchQuery_1.getElasticsearchQueryFromFiltersAndSearch(filters.userFilters);
        const userDocs = yield getUsers(query, projection);
        return userDocs;
    });
}
exports.getUsersByIdsWithProjection = getUsersByIdsWithProjection;
//# sourceMappingURL=getUsersByIdsWithProjection.js.map